export default __webpack_public_path__ + "static/media/logo7.d4eca3da.png";